import React from "react"

function IndicatorAvailableIcon() {
  return (
    <span className="anticon anticon-indiavailable">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 14 14"
      >
        <g id="Badge">
          <g id="Group 512794">
            <circle
              id="Ellipse 673"
              cx="7"
              cy="7"
              r="4.4"
              fill="currentcolor"
              stroke="#60B527"
              strokeWidth="1.2"
            />
            <path
              id="Vector"
              d="M4.99707 7.25L6.24707 8.5L8.75149 6"
              stroke="#60B527"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <rect
            x="1.4"
            y="1.4"
            width="11.2"
            height="11.2"
            rx="5.6"
            stroke="currentcolor"
            strokeWidth="1.2"
          />
        </g>
      </svg>
    </span>
  )
}

export default IndicatorAvailableIcon
